const EXTENDED_FILENAME: RegExp = /filename\*\s*=\s*[^']*'[^']*'([^;]+)/i;
const PLAIN_FILENAME: RegExp = /filename\s*=\s*("([^"]*)"|[^;]+)/i;

export function getContentDispositionFilename(contentDisposition: string | null): string | null {
    if (!contentDisposition) {
        return null;
    }

    return extendedFilename(contentDisposition) ?? plainFilename(contentDisposition);
}

function extendedFilename(contentDisposition: string): string | null {
    const match: RegExpExecArray | null = EXTENDED_FILENAME.exec(contentDisposition);

    if (!match) {
        return null;
    }

    return decode(match[1].trim());
}

function plainFilename(contentDisposition: string): string | null {
    const match: RegExpExecArray | null = PLAIN_FILENAME.exec(contentDisposition);

    if (!match) {
        return null;
    }

    const value: string = (match[2] ?? match[1]).trim();

    return value.length > 0 ? value : null;
}

function decode(value: string): string | null {
    try {
        const decoded: string = decodeURIComponent(value);

        return decoded.length > 0 ? decoded : null;
    } catch {
        return value.length > 0 ? value : null;
    }
}
